import React, { ReactNode, createContext, useState, useEffect } from 'react';

interface AdGlobalRefreshContextInfo {
  shouldGlobalAdsRefresh: boolean;
  refreshGlobalAds: () => void;
}

interface AdGlobalRefreshProviderProps {
  children?: ReactNode;
}

export const AdGlobalRefreshContext = createContext<AdGlobalRefreshContextInfo>({
  shouldGlobalAdsRefresh: false,
  refreshGlobalAds: () => {},
});

export function AdGlobalRefreshProvider({ children }: AdGlobalRefreshProviderProps): JSX.Element {
  const [shouldGlobalAdsRefresh, setShouldGlobalAdsRefresh] = useState(false);

  function refreshGlobalAds(): void {
    setShouldGlobalAdsRefresh(true);
  }

  useEffect(() => {
    if (shouldGlobalAdsRefresh) {
      setShouldGlobalAdsRefresh(false);
    }
  }, [shouldGlobalAdsRefresh]);

  const providerValue = {
    shouldGlobalAdsRefresh,
    refreshGlobalAds,
  };

  return (
    <AdGlobalRefreshContext.Provider value={providerValue}>
      {children}
    </AdGlobalRefreshContext.Provider>
  );
}
